import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Icon, { IconName } from "./icons";
import { T } from "./tokens";

export type Section = "overview" | "password" | "application";

const NAV: { id: Section; icon: IconName; label: string; desc: string }[] = [
  { id: "overview", icon: "user", label: "Account Overview", desc: "Your details & account status" },
  { id: "password", icon: "lock", label: "Change Password", desc: "Set a new login password" },
  { id: "application", icon: "list", label: "My Application", desc: "Review your KYC details" },
];

const useStyles = makeStyles({
  card: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    width: "100%",
    textAlign: "left",
    cursor: "pointer",
    borderRadius: 14,
    padding: "16px 18px",
    transition: "background-color .15s ease, border-color .15s ease, box-shadow .15s ease",
  },
  inactive: {
    background: "#fff",
    // Same 2px width as active so toggling only swaps colour (no reflow/jitter).
    border: `2px solid ${T.hairline}`,
    boxShadow: "0 1px 2px rgba(0,0,0,.03)",
    "&:hover": { background: T.mint, borderColor: "#C3E0CF" },
  },
  active: {
    background: T.mint,
    border: `2px solid ${T.green}`,
    boxShadow: "0 6px 18px rgba(37,97,65,.12)",
  },
});

interface Props {
  active: Section;
  onSelect: (section: Section) => void;
}

const SectionNav: React.FC<Props> = ({ active, onSelect }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      {NAV.map((item) => {
        const on = item.id === active;
        return (
          <Grid item xs={4} key={item.id}>
            <button
              type="button"
              onClick={() => onSelect(item.id)}
              className={`${classes.card} ${on ? classes.active : classes.inactive}`}
            >
              <span
                style={{
                  flexShrink: 0,
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  display: "grid",
                  placeItems: "center",
                  background: on ? T.green : T.mint2,
                }}
              >
                <Icon name={item.icon} size={20} color={on ? "#fff" : T.green} />
              </span>
              <span style={{ display: "flex", flexDirection: "column", gap: 3, flex: 1, minWidth: 0 }}>
                <span style={{ fontWeight: 700, fontSize: 14.5, lineHeight: 1.2, color: T.body }}>
                  {item.label}
                </span>
                <span style={{ fontWeight: 400, fontSize: 11.5, lineHeight: 1.35, color: T.muted2 }}>
                  {item.desc}
                </span>
              </span>
              <Icon name="chevronRight" size={18} color={on ? T.green : "#C8C5BD"} />
            </button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SectionNav;
